/**
 * PublicStatusPage — public-facing system status page.
 *
 * Accessible at /status with no authentication required.
 * Renders the full StatusDashboard component with a clean header and footer.
 */

import { useState } from 'react';
import { StatusDashboard } from '../components/status/StatusDashboard.js';
import { SubscriptionManager } from '../components/status/SubscriptionManager.js';

function PublicHeader() {
  return (
    <header className="bg-white border-b border-neutral-200">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="font-semibold text-neutral-900 text-lg">Martha</span>
          <span className="text-neutral-300">·</span>
          <span className="text-neutral-500 text-sm">Status</span>
        </div>
        <a
          href="/health"
          className="text-xs text-neutral-400 hover:text-neutral-600 font-mono"
          target="_blank"
          rel="noopener noreferrer"
        >
          /health
        </a>
      </div>
    </header>
  );
}

function PublicFooter() {
  return (
    <footer className="border-t border-neutral-200 mt-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-400">
        <span>© Martha by Archie</span>
        <div className="flex items-center gap-4">
          <a
            href="/health"
            className="hover:text-neutral-600 font-mono"
            target="_blank"
            rel="noopener noreferrer"
          >
            GET /health
          </a>
          <a
            href="/api/status/feed.rss"
            className="hover:text-neutral-600"
            target="_blank"
            rel="noopener noreferrer"
          >
            RSS Feed
          </a>
        </div>
      </div>
    </footer>
  );
}

export default function PublicStatusPage() {
  const [subscribeOpen, setSubscribeOpen] = useState(false);

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      <PublicHeader />
      <main className="flex-1">
        <StatusDashboard />
        <div className="max-w-3xl mx-auto px-4 pb-16">
          <div className="bg-white rounded-xl border border-neutral-200 shadow-sm px-5 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <h2 className="text-sm font-semibold text-neutral-800">Get notified about outages</h2>
              <p className="text-xs text-neutral-500 mt-0.5">Subscribe via email or webhook to receive real-time incident notifications.</p>
            </div>
            <button
              onClick={() => setSubscribeOpen(true)}
              className="flex-shrink-0 px-4 py-2 bg-neutral-900 text-white rounded-lg text-sm font-medium hover:bg-neutral-700 transition-colors"
            >
              Subscribe to updates
            </button>
          </div>
        </div>
      </main>
      <PublicFooter />

      <SubscriptionManager
        isOpen={subscribeOpen}
        onClose={() => setSubscribeOpen(false)}
      />
    </div>
  );
}
